import { IconProps } from 'types';

const PromoteIcon = ({ className, title }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={24}
        height={24}
        viewBox="0 0 56 56"
        fill="none"
    >
        <title>{title}</title>
        <path
            fill="currentColor"
            d="M28 48.66c1.219 0 2.11-.867 2.11-2.086V22.902l-.188-5.015l7.055 7.71l5.25 5.18a2.2 2.2 0 0 0 1.5.586c1.195 0 2.039-.89 2.039-2.062c0-.563-.211-1.078-.68-1.57L29.57 12.215a2.4 2.4 0 0 0-1.101-.68h15.304c1.243 0 2.086-.867 2.086-2.086s-.843-2.11-2.086-2.11H12.18c-1.219 0-2.04.891-2.04 2.11s.821 2.086 2.04 2.086h15.35a2.4 2.4 0 0 0-1.101.68L10.938 27.73c-.47.492-.704 1.007-.704 1.57c0 1.172.868 2.062 2.04 2.062c.562 0 1.124-.21 1.5-.586l5.25-5.18l7.054-7.734l-.164 5.04v23.671c0 1.219.867 2.086 2.086 2.086"
        />
    </svg>
);
export default PromoteIcon;
